"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const transactionSigningSelector_1 = require("@/features/transaction-signing/selectors/transactionSigningSelector");
const react_intl_1 = require("react-intl");
const ApprovedStyle_1 = __importDefault(require("./styles/ApprovedStyle"));
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const material_1 = require("@mui/material");
const TransactionSigningApproved = () => {
    const classes = (0, ApprovedStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleToggleCloseApproved = () => {
        console.log('handleToggleCloseApproved');
        dispatch((0, transactionSigningAction_1.dismissTransactionSigningApproved)());
    };
    const { showTransactionSigningApproved, maskedMobileNo } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    return (react_1.default.createElement(material_1.Dialog, { open: showTransactionSigningApproved, classes: { paper: classes.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            } },
            react_1.default.createElement(material_1.Link, { className: classes.IconClose, onClick: handleToggleCloseApproved })),
        react_1.default.createElement(material_1.DialogContent, { className: classes.DialogContent },
            react_1.default.createElement(material_1.Link, { className: classes.WrapIcon }),
            react_1.default.createElement(material_1.ListItem, { className: classes.ListItem },
                react_1.default.createElement(material_1.ListItemText, null,
                    react_1.default.createElement(material_1.Typography, { className: classes.typography },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-approved-message-1" })),
                    react_1.default.createElement(material_1.Typography, { className: `${classes.typography} ${classes.tips2}` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-approved-message-2" })),
                    react_1.default.createElement(material_1.Typography, { className: `${classes.typography} ${classes.tips3}` }, maskedMobileNo))))));
};
exports.default = TransactionSigningApproved;
